import { ISelectValue, SelectProps } from './select.types';

import { Select } from './select';

type AsyncSelectProps = Omit<SelectProps, 'onSearchChange'> & {
  onSearch: (query: string) => void;
  selectedOptions?: ISelectValue[];
  loading?: boolean;
};

export const AsyncSelect = (props: AsyncSelectProps) => {
  const {
    onSearch,
    selectedOptions,
    options,
    loading,
    noOptionsMessage,
    ...selectProps
  } = props;

  const value = selectProps.multi ? (selectProps.value as string[]) : [];
  const isInitialLoading =
    loading && value.length > 0 && !selectedOptions?.length;

  return (
    <Select
      {...(selectProps as SelectProps)}
      loading={isInitialLoading}
      options={options}
      selectedValueOptions={selectedOptions}
      hideSelected
      onSearchChange={onSearch}
      noOptionsMessage={loading ? 'Загрузка...' : noOptionsMessage}
    />
  );
};
